var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" 參數設定 ")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])], 1)], 1)])]), _c('b-tabs', [_c('b-tab', {
    attrs: {
      "title": "參數設定",
      "lazy": ""
    }
  }, [_c('parameter-form', {
    attrs: {
      "has-line-merchant": _vm.hasLineMerchant
    }
  })], 1), _c('b-tab', {
    attrs: {
      "title": "功能啟用",
      "lazy": ""
    }
  }, [_c('enable-feature-form', {
    attrs: {
      "has-line-merchant": _vm.hasLineMerchant
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }